module.exports = __webpack_public_path__ + "9298f3c9fc31b7957e0cfc53690ea06d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-18.png
// module id = 2145
// module chunks = 0